import { render, staticRenderFns } from "./autocompleteKeyWords.vue?vue&type=template&id=0b5fdbd4&lang=pug"
import script from "./autocompleteKeyWords.vue?vue&type=script&lang=js"
export * from "./autocompleteKeyWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports